// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 278) return "static/chunks/278.de67b9485bf14b1a.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 566 ? "b74d76a4" : chunkId) + "-" + {"196":"954415e4ab27c5ac","566":"802b469d1fb91e1b","694":"ab135138a080bc37"}[chunkId] + ".js";
};